// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filtersLayoutStyles } from "@awc/App/Widgets/OrderHistory/OrderHistoryFiltersLayout";
import { DivWrapper } from "@awc/XDL/constants";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

filtersLayoutStyles.container = {
    css: css`
        padding: 10px;
        & > ${DivWrapper} {
            display: flex;
            gap: 16px;
            flex-wrap: wrap;
            align-items: flex-start;
            margin-left: auto;
            & > div:last-child {
                width: 100%;
                margin-left: auto;
                justify-content: flex-end;
                align-items: end;
            }
        }
    `,
};
